import Announcements from '../tools/announcements';

export default {
	init() {
	},
	finalize() {
		console.log('home finalize firing');
		const a = new Announcements();
		console.log('el:', a.el);
		console.log('track:', a.track);
		console.log('count:', a.count);
		console.log('timer:', a.timer);
	}
};
